import React, { MouseEventHandler, ReactNode } from "react";
import * as Styled from "./FormField.styles";
import { Box, FormControl, Tooltip, Typography } from "@mui/material";
import { AppInfoIcon } from "../Icon/AppInfoIcon";
import { Translations } from "../../../models/translations";

interface FormFieldProps {
  children?: ReactNode;
  className?: string;
  title: string | ReactNode;
  buttons?: ReactNode;
  fitToContainerHeight?: boolean;
  titleColor?: string;
  required?: boolean;
  color?: string;
  fullWidth?: boolean;
  error?: string;
  keepLineBreaks?: boolean;
  margin?: string | number;
  padding?: string | number;
  overflow?: "hidden" | "auto" | "visible";
  getInfoDocument?: () => Promise<void>;
  onClick?: MouseEventHandler<HTMLDivElement>;
}

export const FormField = ({
    children,
    className,
    title,
    buttons,
    fitToContainerHeight,
    titleColor,
    required = false,
    fullWidth = true,
    error,
    keepLineBreaks = false,
    margin,
    padding,
    color,
    overflow = "hidden",
    getInfoDocument,
    onClick
}: FormFieldProps) => {
    return (
        <FormControl
            className={className}
            fullWidth={fullWidth}
            sx={{
                margin: margin ?? "1.5rem 0 0 0",
                padding,
                color,
                display: "flex",
                flexDirection: "column",
                overflow,
                whiteSpace: keepLineBreaks ? "pre-line" : "initial",
                height: fitToContainerHeight ? "100%" : undefined,
            }}
            onClick={onClick}
        >
            {!!title && (
                <Styled.Label>
                    <Box display="flex" sx={{ alignItems: "center" }}>
                        <Box>
                            <Typography variant="caption" sx={{ color: titleColor ?? "text.secondary" }}>
                                {title}
                            </Typography>{" "}
                            {required
                                ? (
                                    <Typography variant="caption" color="error" marginLeft=".25rem">
                                    *
                                    </Typography>
                                )
                                : null}
                        </Box>
                        {!!getInfoDocument &&
                            <Tooltip title={Translations.Info}>
                                <AppInfoIcon
                                    color="info"
                                    sx={{ marginLeft: "auto", cursor: "pointer", marginBottom: "-5px" }}
                                    onClick={getInfoDocument}
                                />
                            </Tooltip>
                        }
                        {buttons}
                    </Box>
                </Styled.Label>
            )}
            {children}
            {error
                ? (
                    <Styled.Error variant="caption" color="error">
                        {error}
                    </Styled.Error>
                )
                : null}
        </FormControl>
    );
};
